export default "__VITE_PUBLIC_ASSET__10d49a4e__"